


import React, { useCallback, useState} from "react";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
//import styles from './index.module.css';

const ModalContact = (props) => {
  // stores current formRef
  const [node, setNode] = useState("");
  // tracks changes to formRef and stores current with setNode
  const formRef = useCallback((node) => {
    setNode(node);
  }, []);

 
  return (
    <div className="modalformWrapper" id="generateLead">
      {node && (
        // dynamically renders the custom form header
        <div className="modalformHeader">
          {props.header ? props.header : "Please fill the information below to continue"}
        </div>
      )}
      <div className="formBody">
        <BorrowerLeadGenerationTool
          ref={formRef} leadSource="swmc.com"
          loanOfficerUid="CSTC"
          statesDomain={process.env.REACT_APP_STATE_DOMAIN}
        />
      </div>
    </div>
  );
};

export default ModalContact;
